import React, { useState } from 'react';
import { Box } from 'native-base';
import {
    useI18n,
    useTheme,
    useUpdateMember,
    validateEmail
} from '@springbig/shared';
import { Caption, H3 } from '~/shared/Typography';
import { useToast } from '~/hooks/toast';
import dayjs from 'dayjs';
import { Button, Modal, Input } from '~/shared/Theme';

export type AutoConnectFieldType = 8 | 10;

type ConditionalFormType = {
    isOpen: boolean;
    closeModal: () => void;
    fieldType: AutoConnectFieldType;
};

const ConditionalForm = ({ fieldType, isOpen, closeModal }: ConditionalFormType) => {

    const [email, setEmail] =
        useState('');

    const [birthday, setBirthday] =
        useState(dayjs(new Date()).format('YYYY-MM-YY'));

    const { mutate: updateMember, isLoading } =
        useUpdateMember();

    const {
        field_background,
        field_color,
        field_border,
        field_border_size,
        radius_sm,
    } = useTheme();

    const { t } = useI18n();
    const { errorToast } = useToast();

    const handleFormSubmit = () => {

        if (fieldType === 10) {
            const isEmailValid = validateEmail(email);
            if (isEmailValid) {
                updateMember({
                    member: {
                        email
                    }
                });
                closeModal();
            }
            else {
                errorToast(t('errors.invalid_email'));
            }
        }
        else if (fieldType === 8) {

            const today = new Date().toISOString().slice(0, 10); // Get today's date in "yyyy-mm-dd" format

            if (birthday < today) {
                updateMember({
                    member: {
                        birthday
                    }
                });
                closeModal();
            }
            else {
                errorToast(t('errors.birthday_in_past'));
                setBirthday('');
            }
        }
    };

    return (
        <Modal isOpen={isOpen}>
            <Modal.Header textAlign={'center'}>
                <H3 textTransform={'capitalize'}>
                    {`${t('general.update')} ${fieldType === 8 ? t('general.birthday') : t('general.email')}`}
                </H3>
            </Modal.Header>
            { fieldType === 8 &&
                    <Box width={'100%'} alignContent={'center'} p={8}>
                        <input
                            style={{
                                backgroundColor: field_background,
                                borderColor: field_border,
                                color: field_color,
                                borderRadius: radius_sm,
                                borderWidth: field_border_size,
                                height: '40px',
                                borderStyle: 'solid',
                                paddingInline: 8,
                                fontSize: 16,
                                width: '92%',
                            }}
                            type="date"
                            value={birthday}
                            onChange={e => setBirthday(e.target.value)}
                            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                            required
                            max={birthday}
                        />
                    </Box>
            }

            { fieldType === 10 &&
                    <Box p={8}>
                        <Caption text='general.update' />
                        <Input
                            onChangeText={(_text: string) => setEmail(_text)}
                            value={email}
                            keyboardType="email-address"
                            placeholder={t('general.email_example')}
                        />
                    </Box>
            }

            <Modal.Footer>
                <Button
                    text={'general.cancel'}
                    variant={'text'}
                    onPress={closeModal}
                    loading={isLoading}
                />
                <Button
                    text={'general.update'}
                    onPress={handleFormSubmit}
                    loading={isLoading}
                />
            </Modal.Footer>
        </Modal>
    );

};

export default ConditionalForm;
